import "./App.css";
import axios from "axios";

import { Route, Switch, useHistory } from "react-router-dom";
// component

// css
import "./assets/css/bootstrap.min.css";
import "./assets/css/plugins.css";
import "./assets/css/structure.css";
import "./assets/css/scrollspyNav.css";
import "./assets/css/custom.css";

// js

// import "./assets/js/perfect-scrollbar.min.js";
import "./assets/js/bootstrap/js/bootstrap.min.js";
import "./assets/js/bootstrap/js/popper.min";
import "./assets/js/app.js";
// import "./assets/js/custom";
// import "./assets/js/scrollspyNav.js";

import { Suspense, lazy } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { LOGIN_ADMIN, LOGOUT_ADMIN } from "./store/Admin/admin.type";
import { logoutAdmin } from "./store/Admin/admin.action";
import setToken from "./util/setToken";
import { useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { IdleTimeoutManager } from "idle-timer-manager";

import Registration from "./Pages/Registration";
import UpdateCode from "./Pages/UpdateCode";
import Login from "./Pages/Login";
import Admin from "./Pages/Admin";
import AuthRoute from "./util/AuthRoute";
import PrivateRouter from "./util/PrivateRoute";

function App() {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [login, setLogin] = useState(true);

  useEffect(() => {
    axios
      .get("/login")
      .then((res) => {
        setLogin(res.data.login);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const isAuth = sessionStorage.getItem("isAuth");
  const dispatch = useDispatch();
  const key = sessionStorage.getItem("key");
  const token = sessionStorage.getItem("token");

  useEffect(() => {
    // Expose instant test trigger in browser console: window.__testSessionTimeout()
    window.__testSessionTimeout = () => setOpen(true);

    const manager = new IdleTimeoutManager({
      timeout: 1200, // 20 min idle timeout (in seconds)
      onExpired: (time) => {
        setOpen(true);
      },
    });

    return () => {
      delete window.__testSessionTimeout;
      manager.clear();
    }; //eslint-disable-next-line
  }, []);

  const handleClose = () => {
    setOpen(false);
    dispatch(logoutAdmin(history));
  };

  return (
    <>
      <Switch>
        <AuthRoute exact path="/" component={login ? Login : Registration} />
        {isAuth && <Route path="/admin" component={Admin} />}
        <PrivateRouter path="/admin" component={Admin} />
        {login && <AuthRoute exact path="/code" component={UpdateCode} />}
        {login && <AuthRoute exact path="/loginAdmin" component={Login} />}
        {login && <AuthRoute path="/Registration" component={Registration} />}
      </Switch>

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: "420px",
            maxWidth: "90%",
            borderRadius: "18px",
            backgroundColor: "#201f35",
            textAlign: "center",
            padding: "20px",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            boxShadow: "0 15px 40px rgba(0,0,0,0.6)",
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="session-dialog text-center">
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              className="text-white"
              style={{ fontSize: "20px", fontWeight: "600", marginBottom: "8px" }}
            >
              Session Timed Out
            </DialogContentText>
            <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px", margin: 0 }}>
              Your session has expired due to inactivity. Please sign in again.
            </p>
          </DialogContent>
        </div>
        <DialogActions className="justify-content-center mt-3">
          <button
            className="btn px-4 py-2"
            style={{
              background: "linear-gradient(135deg, #d532ee 0%, #e8538f 100%)",
              color: "#fff",
              borderRadius: "10px",
              fontWeight: "600",
              border: "none",
            }}
            onClick={handleClose}
          >
            Sign out
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default App;
